import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  Card,
  CardQuery,
  MemberCard,
  MemberCardQuery,
  MemberDetails,
  MemberQuery,
  NotificationCenterQuery,
  ProductCodeQuery,
  TMAuthService,
} from '@fgb/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-mobile-nav-menu',
  templateUrl: './mobile-nav-menu.component.html',
  styleUrls: ['./mobile-nav-menu.component.scss'],
})
export class MobileNavMenuComponent implements OnInit, OnDestroy {
  productcode = ProductCode;
  memberDetails$: Observable<MemberDetails | undefined>;
  memberCard$: Observable<MemberCard | undefined>;
  selectedMember: string;
  cards$: Observable<Card[]>;
  unseenNotificationCount$: Observable<number>;
  season: boolean;
  premium: boolean;
  sgb: boolean;

  constructor(
    private tmAuthService: TMAuthService,
    private router: Router,
    private memberQuery: MemberQuery,
    private memberCardQuery: MemberCardQuery,
    private cardQuery: CardQuery,
    private notificationQuery: NotificationCenterQuery,
    private productCodeQuery: ProductCodeQuery
  ) {}
  private routerSubscription: Subscription;
  public isCollapsed = true;

  ngOnInit() {
    this.initMemberAccounts();
    this.routerSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        tap(() => (this.isCollapsed = true))
      )
      .subscribe();
    this.unseenNotificationCount$ = this.notificationQuery.unseenNotificationsCount$;
    this.season = this.productCodeQuery.currentUserIsProductCode(ProductCode.Season);
    this.premium = this.productCodeQuery.currentUserIsProductCode(ProductCode.Premium);
    this.sgb = this.productCodeQuery.currentUserIsProductCode(ProductCode.SGB);
  }

  initMemberAccounts() {
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
    this.cards$ = this.cardQuery.selectCards();
    this.selectedMember = this.memberQuery.getUserContext().memberId;
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  logout() {
    this.tmAuthService
      .logout()
      .pipe(tap(() => this.router.navigate(['/login'])))
      .toPromise();
  }
}
